var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-list"},[(_vm.noData)?_c('div',{staticClass:"noData"},[_c('p',[_vm._v("没有搜索到任何数据")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"meetings"},[_vm._l((_vm.articlesList),function(item){return [_c('item-block',{key:item.id,attrs:{"itemContent":item}})]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b29306e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Vow/Search/List.vue
// module id = null
// module chunks = 